export default __webpack_public_path__ + "static/media/techblog3-fig2.f54a6d9f.png";